import {
    get,
    isArray,
    isEmpty,
    isNaN,
    isNil,
    isNull,
    isNumber,
    isObject,
    isString,
    isUndefined,
    now,
    omitBy,
    reject,
    snakeCase
} from 'lodash';
let _ = require('underscore');
const { btoa, atob } = require('abab');
const shallowEquals = require('shallow-equals');


// NOTE does not recurse
// strict requires same order as well (equals?)
//
export function compareArray(arrayA, arrayB, strict)
{
    if (!arrayA && !arrayB) { return true; } //can return true for non arrays
    if (!arrayA || !arrayB) { return false; }

    if (!_.isArray(arrayA) || !_.isArray(arrayB)) { return false; }
    if (arrayA.length !== arrayB.length) { return false; }

    if (!strict) {
        //return compareArray(arrayA.sort() , arrayB.sort(), true);
        arrayA = arrayA.sort();  //TBD defualt sort - what does that do?
        arrayB = arrayB.sort();
    }

    for (var i = 0, l = arrayA.length; i < l; i++) {
        if (arrayA[i] !== arrayB[i]) {
            return false;
        }
    }
    return true;
}

// return an ordered array
// data = object/array
// order = array of keys
// keyname = key property if data is an array
// missingDefault = what to do if a key in order is missing from data
//      false -> omit from result
//      <value> -> include with value
//      <function> - include with function(key) result
//      (if you need <value> of false use a function to always return false - key=>false)
//
export function orderBy(data,order,keyName, missingDefault)
{
    if ((data instanceof Array) && keyName)
    {
        data =_.indexBy(data,keyName);
    }
    if (! _.isObject(data)) return data;

    if (! (order instanceof Array)) return _.values(data);

    var sortOrder = order;
    if (missingDefault === false)
    {
        // strip out missing items
        sortOrder = _.intersection(order, _.pluck(data, keyName)) ;
        missingDefault = undefined ;  //shouldn't be used anyway
    }

    return _.map(sortOrder, function(key){
        return data[key] ||
            ( _.isFunction(missingDefault)
                ? missingDefault(key)
                : missingDefault );
    });
}

// Note only good to 6 zeros
export function zeroPad(value,length)
{
    length = length||2;
    value = value > 0 ? value : '';
    return ("000000"+value).slice(- length);
}

export function utoa(str) {
    return btoa(unescape(encodeURIComponent(str)));
}
// base64 encoded ascii to ucs-2 string
export function atou(str) {
    return decodeURIComponent(escape(atob(str)));
}

// '6.66666' ->  6.67 ,  '10.00' -> 10
export function round(num, digits){
    return Number(Number(num).toFixed(digits));
}


export function pixelsToInches(pixels, dpi=72, digits=3) {
    const p = parseInt(pixels);
    return round(p/dpi,digits)
}

export function inchesToPixels(inches, dpi=72) {
    return Math.round(inches * dpi);
}

// field Reducer helper
export const fieldReducer = (oldState, actions) => {

    actions = _.isArray(actions) ? actions : [actions];
    const newState = Object.assign({},oldState);
    let changed = false;

    actions.forEach( (action) => {
        if (action.type !== 'forceUpdate' && !(action.field in oldState)) {
            // i.e. Only support fields in initial state
            throw new Error("Unknown field: "+action.field);
        }

        switch (action.type) {
            case 'forceUpdate':
                changed = true;
                break;
            case 'remove':
                if (newState[action.field].includes(action.value)) {
                    newState[action.field] = newState[action.field].filter(tag => tag !== action.value);
                    changed = true;
                }
                break;
            case 'add':
                if (!newState[action.field].includes(action.value)) {
                    newState[action.field] = newState[action.field].concat([action.value]);
                    changed = true;
                }
                break;
            case 'replace':
                // Todo use compareArray compareObject?
                if (newState[action.field] !== action.value) {
                    newState[action.field] = action.value;
                    changed = true;
                }
                break;
            default:
                throw new Error("Unspported reducer action");
        }
    });

    return changed ? newState : oldState;
};

// will just attempt to replace any values in the oldState with all values from the newState
// so sub structures will trigger change (unless the are the same underlying object)
export function objectReplaceReducer(oldState, newState)
{
    return fieldReducer(oldState,
        Object.keys(newState)
            .map((field)=>{
                return {
                    type:'replace',
                    field,
                    value:newState[field]
                };
            })
    );
}

// this should be quicker than objectReplaceReducer and will work on arrays too
// Also does not require pre-declaring fields in useReducer init
export function shallowReducer(oldState, newState) {
    return shallowEquals(oldState, newState) ? oldState : newState;
}

// takes array or object and replaces values with instances of type
export function newObjectList(list, type)
{
    return ( _.isArray(list) ? _.map : _.mapValues )(list, function(item){
        return new type(item);
    });
}

export function getIfDef (rec,path){
    if (isNil(path)) {
        return rec;
    }
    const val = get(rec,path);
    return isUndefined(val) ? rec : val;
}

export function alphaCompare(a, b, getPath) {
    const getVal = rec=>
        String(getIfDef(rec,getPath)).toUpperCase().trim();

    var nameA = getVal(a);
    var nameB = getVal(b);
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
}

export function numericCompare(a, b, getPath) {
    const getVal = rec=>
        parseFloat(getIfDef(rec,getPath));

    var numA = getVal(a);
    var numB = getVal(b);

    return numA - numB;
}

export function baseName(path) {
    return path.split('/').reverse()[0];
}

export function getSpecAdFileName({jobNumber,metroReference}, ext){
    return snakeCase(jobNumber||metroReference) + (ext?'.'+ext:'')
}

export function getAttachment(href, fileBase){
    const url = new URL(href);
    const ext =  url.pathname.split('.').pop();
    const filename = fileBase + '_' + now() + (ext.toLowerCase()==='jpg' ? '.jpg' : '.png');

    return {
        filename,
        cid: filename,
        href
    }
}


//NOTE this maybe be too heavy handed for object - blank properties may have meaning
export function isBlank(value) {
    return isNull(value) || isUndefined(value) || (
        isNumber(value)
            ? isNaN(value) //Note  0 is a valid value!
            : isString(value)
                ? value.trim().length === 0
                : isArray(value)
                    ? reject(value, isBlank).length === 0
                    : isObject(value)
                        ? isEmpty(omitBy(value, isBlank))
                        : false  // we don't know so say it isn't
    )
}

//lodash mixin
//mixin({isBlank}) // not spotted by IDE so no type a head help... :-(